import { chainWalk } from '../../../../utils/helpers';

export const SINGLES_ROLES = ['singlespick', 'singlespack'];

export const getSinglesEnabled = (plan) => {
  return chainWalk(() => JSON.parse(plan.input.adminSettings).singles_enabled, false);
};
